<div class="formgrid grid">
  <div class="field col-12">
    <label>Extensión *</label>
    <p-dropdown [options]="extensions" [(ngModel)]="selectedExtension" optionLabel="label" optionValue="value"
      placeholder="Seleccione una extensión" appendTo="body" [filter]="true" filterBy="label"></p-dropdown>
  </div>
</div>

<div class="flex justify-content-end gap-2 mt-3">
  <p-button label="Cancelar" severity="secondary" (click)="cancel()"></p-button>
  <p-button label="Añadir" icon="pi pi-plus" (click)="save()" [loading]="saving"></p-button>
</div>
